import { Children, isValidElement } from 'react';
import { Flex, FlexProps, Icon, IconName, Paragraph } from '../../../../atoms';

export function IconLinkCard({
  title,
  children,
  ...rest
}: FlexProps & { title: string }): JSX.Element {
  let icon: JSX.Element | null = null;
  Children.forEach(children, (child) => {
    if (!isValidElement(child)) {
      return;
    }
    if (child.type === Icon) {
      icon = child;
    }
  });
  return (
    <Flex
      cursor="pointer"
      pr="space_unit.x4"
      pl="space_unit.x2"
      backgroundColor="palette_blue.0"
      alignItems="center"
      w="100%"
      justifyContent="space-between"
      boxShadow="0px 2px 4px 0px #20253208"
      _hover={{ boxShadow: '0px 2px 8px 0px #20253214' }}
      {...rest}
    >
      <Flex alignItems="center">
        {icon && icon}
        <Paragraph ml="space_unit.x1" color="palette_gray.100">
          {title}
        </Paragraph>
      </Flex>
      <Icon color="palette_blue.100" w="10px" name={IconName.ArrowRight} />
    </Flex>
  );
}

IconLinkCard.Icon = Icon;
